import Vue from 'vue'
import createHistory from 'history/createBrowserHistory'

import Page01 from './components/Page-01'
import Page02 from './components/Page-02'
import Page03 from './components/Page-03'
import Page04 from './components/Page-04'
import Page05 from './components/Page-05'
import Page06 from './components/Page-06'
import Page07 from './components/Page-07'
import Page08 from './components/Page-08'
import Page09 from './components/Page-09'
import Page09Iframe01 from './components/Page-09-Iframe-01'
import Page10 from './components/Page-10'
import Page11 from './components/Page-11'
import Page12 from './components/Page-12'
import Page13 from './components/Page-13'
import Page14 from './components/Page-14'

const history = createHistory()
global.jQuery = require('jquery')
var $ = global.jQuery
window.$ = $


// Components
Vue.component('page-01', Page01)
Vue.component('page-02', Page02)
Vue.component('page-03', Page03)
Vue.component('page-04', Page04)
Vue.component('page-05', Page05)
Vue.component('page-06', Page06)
Vue.component('page-07', Page07)
Vue.component('page-08', Page08)
Vue.component('page-09', Page09)
Vue.component('page-09-iframe-01', Page09Iframe01)
Vue.component('page-10', Page10)
Vue.component('page-11', Page11)
Vue.component('page-12', Page12)
Vue.component('page-13', Page13)
Vue.component('page-14', Page14)

new Vue({
  el: '#demotourapp',
  /////////////////////////////////////////////////////
  // Data
  /////////////////////////////////////////////////////
  data() {
    return {
      step: 0,
      dataLoaded: false
    }
  },
  /////////////////////////////////////////////////////
  // Mounted
  /////////////////////////////////////////////////////
  mounted() {
    $(document).on('click', 'a', function (e) {
      if (!$(this).hasClass('dont-prevent')) {
        e.preventDefault()

        if (!($(this).hasClass('dont-shake'))) {
          $('.dt-step').removeClass('dt-step-attention')
          setTimeout(function () {
            $('.dt-step').addClass('dt-step-attention')
          }, 1)
          setTimeout(function () {
            $('.dt-step').removeClass('dt-step-attention')
          }, 500)
        }

        return false
      } else {
        return true
      }
    })

    $(document).on('click', 'button', function (e) {
      if (!$(this).hasClass('dont-prevent')) {
        e.preventDefault()

        if (!($(this).hasClass('dont-shake')) && !($(this).parent().hasClass('dt-step__cta--button'))) {
          $('.dt-step').removeClass('dt-step-attention')
          setTimeout(function () {
            $('.dt-step').addClass('dt-step-attention')
          }, 1)
          setTimeout(function () {
            $('.dt-step').removeClass('dt-step-attention')
          }, 500)
        }

        return false
      } else {
        return true
      }
    })

    if (!history.location.hash) {
      location.hash = 1
      this.step = 1
    } else {
      this.step = parseInt(location.hash.replace('#', ''))
    }

    const unlisten = history.listen((location, action) => {
      this.step = parseInt(location.hash.replace('#', ''))
    })

    this.dataLoaded = true
  },
  /////////////////////////////////////////////////////
  // Methods
  /////////////////////////////////////////////////////
  methods: {
    nextStep(data) {
      this.step = data
      location.hash = this.step
    },
    prevStep(data) {
      this.step = data
      location.hash = this.step
    }
  }

})



// WEBPACK FOOTER //
// ./_vue/app.js